import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconBookmarkLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 29,
	height: 28,
	viewBox: "0 0 29 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "icon/bookmark-line",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M20.334 3.5H8.66732C7.38398 3.5 6.34565 4.55 6.34565 5.83333L6.33525 22.4824C6.33473 23.3097 7.28169 23.7797 7.94033 23.2792L14.5007 18.2933L21.0622 23.2801C21.7206 23.7805 22.6673 23.311 22.6673 22.484V5.83333C22.6673 4.55 21.6173 3.5 20.334 3.5ZM20.334 19.8333L15.1253 15.6664C14.7601 15.3742 14.2412 15.3742 13.876 15.6664L8.66732 19.8333V5.83333H20.334V19.8333Z",
			fill: "#C0C0C0"
		})
	})
});
export default SvgIconBookmarkLine;
